import CardStockValidation from './CardStockValidation';

export default CardStockValidation;
